//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/NXObject.js";
import "../no/LayoutDefinition.js";
let d=[[[0,"Definition",0,"LayoutDefinition",0],[0,"DisplayStatus",0,0],[0,"WorkView",0,"View",0]],[[["view","row","column","perform_fit_view"],"ReplaceView",{},4,0],[["old_view","new_view","perform_fit_view"],"ReplaceView1",{},3,0],[["num_views"],"GetViews",{R_:{views:"View[]"}},0,0],[[],"Open",{},0,0],[[],"Save",{},0,0],[["layout_name"],"SaveAs",{R_:{new_layout:"Layout"}},1,0]],[]];
SPLM.Layout = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Layout";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;